<template>
  <component
    :is="resolveLayoutVariant"
    v-if="!loadingI18n"
    :class="`skin-variant--${appSkinVariant}`"
  >
    <transition
      :name="appRouteTransition"
      mode="out-in"
      appear
    >
      <router-view></router-view>
    </transition>
    <AppIdle />
    <!--<LoadCache />-->
  </component>
</template>

<script>
import { mapState } from 'vuex'
// eslint-disable-next-line object-curly-newline
import { computed } from '@vue/composition-api'
// eslint-disable-next-line import/no-unresolved
import useAppConfig from '@core/@app-config/useAppConfig'
// eslint-disable-next-line import/no-unresolved
import { useRouter } from '@core/utils'
// eslint-disable-next-line import/no-unresolved
import { useLayout } from '@core/layouts/composable/useLayout'

// Layouts
// eslint-disable-next-line import/no-unresolved
import LayoutContentVerticalNav from '@/layouts/variants/content/vertical-nav/LayoutContentVerticalNav.vue'
// eslint-disable-next-line import/no-unresolved
import LayoutContentHorizontalNav from '@/layouts/variants/content/horizontal-nav/LayoutContentHorizontalNav.vue'
// eslint-disable-next-line import/no-unresolved
import LayoutBlank from '@/layouts/variants/blank/LayoutBlank.vue'
// eslint-disable-next-line import/no-unresolved
import LoadCache from '@/views/utils/cache/LoadCache.vue'

// Dynamic vh
// eslint-disable-next-line import/no-unresolved
import useDynamicVh from '@core/utils/useDynamicVh'
// eslint-disable-next-line no-unused-vars, import/no-unresolved
import AppIdle from '@core/layouts/components/app-bar/AppIdle.vue'
// eslint-disable-next-line import/extensions
// import LoadCacheMixin from './mixins/LoadCacheMixin.js'

// eslint-disable-next-line import/no-unresolved, import/extensions
import LoadCacheDataGeneralMixin from '@/mixins/LoadCacheDataGeneralMixin.js'

export default {
  components: {
    LayoutContentVerticalNav,
    LayoutContentHorizontalNav,
    LayoutBlank,
    AppIdle,
    LoadCache,
  },

  mixins: [
    LoadCacheDataGeneralMixin,

    // LoadCacheMixin,
  ],
  setup() {
    const { route } = useRouter()
    const { appContentLayoutNav, appSkinVariant, appRouteTransition } = useAppConfig()

    const { handleBreakpointLayoutSwitch } = useLayout()
    handleBreakpointLayoutSwitch()

    const resolveLayoutVariant = computed(() => {
      if (route.value.meta.layout === 'blank') return 'layout-blank'
      if (route.value.meta.layout === 'content') return `layout-content-${appContentLayoutNav.value}-nav`

      return null
    })

    useDynamicVh()

    return {
      resolveLayoutVariant,
      appSkinVariant,
      appRouteTransition,
    }
  },
  computed: {
    ...mapState({
      loadingI18n: state => state.app.loadingI18n,
    }),
  },
}
</script>

<style>
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
